import Vue from "vue";

export async function getExternalStatusesDistinct() {
    const response = await Vue.prototype.$http.get(
        '/services/external_statuses'
    );

    return response.data
}